import * as Y from 'yjs';

/**
 * Read a value from a Yjs map, converting nested Y.Maps to plain objects.
 * Handles both legacy (plain object) and new (nested Y.Map) storage formats.
 */
export function readYjsValue<T = Record<string, unknown>>(raw: unknown): T {
  if (raw instanceof Y.Map) {
    return raw.toJSON() as T;
  }
  return raw as T;
}

/**
 * Read a shape from a Yjs shapes map by ID, handling both formats.
 */
export function readShapeFromYjs(
  shapesMap: Y.Map<unknown>,
  id: string
): Record<string, unknown> | undefined {
  const raw = shapesMap.get(id);
  if (raw == null) return undefined;
  return readYjsValue<Record<string, unknown>>(raw);
}

/**
 * Iterate shapes in a Yjs map, converting each to a plain object.
 */
export function forEachShape(
  shapesMap: Y.Map<unknown>,
  fn: (shape: Record<string, unknown>, id: string) => void
): void {
  shapesMap.forEach((raw, id) => {
    if (raw != null) {
      fn(readYjsValue<Record<string, unknown>>(raw), id);
    }
  });
}
